import { render, staticRenderFns } from "./formtitle.vue?vue&type=template&id=41f51a4a"
import script from "./formtitle.vue?vue&type=script&lang=js"
export * from "./formtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports